import { initPostHogClient } from '@findigs/helpers/src/integrations/posthog/posthog.client';
import type { InitPostHogClientProps } from '@findigs/helpers/src/integrations/posthog/posthog.client';
import { useEffect } from 'react';

/**
 * This function is meant to only be called once in `root.tsx` to initialize
 * the client-side portion of the PostHog integration
 *
 * Note: this hook is SSR-safe
 **/
export function usePostHogInitClient({
  key,
  distinctId,
}: InitPostHogClientProps) {
  useEffect(() => {
    initPostHogClient({ key, distinctId });
  }, [key, distinctId]);
}
